import React from "react";
import { Container } from "react-bootstrap";
import "./Disclaimer.css";

const Disclaimer = () => {
  return (
    <section className="disclaimer-page">
      <Container>

        <h1 className="disclaimer-heading">Disclaimer</h1>

        <h2 className="disclaimer-subheading">Important Legal Notice</h2>

        <p>
          The information provided by Plenary Holidays on this website and within our travel proposals is for general informational purposes only.
        </p>

        <p>
          While we endeavour to keep all information accurate and up to date, we make no representations or warranties, express or implied, regarding the completeness, accuracy, reliability, suitability, or availability of any content, pricing, or services offered by third-party suppliers.
        </p>

        <p>
          Any reliance placed on such information is strictly at the user’s own risk.
        </p>

        <hr />

        <h3>1. Role as Intermediary & Limitation of Liability</h3>

        <p>
          Plenary Holidays acts solely as an intermediary (facilitator) between the traveler and independent service providers including, but not limited to:
        </p>

        <ul>
          <li>Airlines</li>
          <li>Hotels</li>
          <li>Transport operators</li>
          <li>Event venues</li>
          <li>Destination Management Companies (DMCs)</li>
        </ul>

        <h4>Third-Party Actions</h4>

        <p>
          We shall not be held responsible for any loss, injury, damage, delay, or inconvenience arising from the acts, omissions, or defaults of any third-party supplier.
        </p>

        <h4>Service Standards</h4>

        <p>
          While we conduct vendor due diligence in line with professional industry standards (including GAEHP practices), we do not own or control airlines, hotels, or transport providers. Therefore, we cannot be held liable for service deficiencies, operational disruptions, or supplier-side failures.
        </p>

        <p>
          Our maximum liability, if established, shall be limited to the amount paid to us for the specific service in question.
        </p>

        <hr />

        <h3>2. Force Majeure (Acts Beyond Our Control)</h3>

        <p>
          Plenary Holidays shall not be liable for failure or delay in performance due to circumstances beyond our reasonable control, including but not limited to:
        </p>

        <ul>
          <li>Natural disasters (landslides, earthquakes, floods, etc.)</li>
          <li>Political unrest, strikes, civil disturbances</li>
          <li>Government-imposed restrictions or lockdowns</li>
          <li>Airline technical failures or airport closures</li>
          <li>Sudden changes in permit regulations (particularly in regions such as Sikkim and North-East India)</li>
          <li>Public health emergencies</li>
        </ul>

        <p>
          Any additional expenses incurred due to such events shall be borne by the client, subject to supplier policies and prevailing contractual terms.
        </p>

        <hr />

        <h3>3. Pricing, Errors & Rate of Exchange (ROE)</h3>

        <h4>Pricing & Availability</h4>

        <p>
          All prices displayed on the website or quoted in preliminary proposals are indicative and subject to availability at the time of confirmation.
        </p>

        <h4>Errors & Omissions</h4>

        <p>
          In the event of human, system, or typographical errors, Plenary Holidays reserves the right to correct and re-invoice the accurate pricing before final booking confirmation.
        </p>

        <h4>Rate of Exchange (ROE) Fluctuations</h4>

        <p>
          Prices quoted for international travel are subject to fluctuations in foreign exchange rates. Final pricing is confirmed only upon receipt of 100% payment or as per agreed payment milestones.
        </p>

        <hr />

        <h3>4. Visa, Travel Documentation & Fitness to Travel</h3>

        <h4>Travel Documentation</h4>

        <p>
          It is the sole responsibility of the traveler to ensure:
        </p>

        <ul>
          <li>Valid passport (minimum 6 months validity where applicable)</li>
          <li>Required visas</li>
          <li>Travel permits</li>
          <li>Vaccination certificates</li>
          <li>Compliance with entry/exit regulations</li>
        </ul>

        <p>
          Plenary Holidays shall not be liable for deportation, boarding denial, visa rejection, or any losses arising from incomplete or invalid documentation.
        </p>

        <h4>Fitness to Travel</h4>

        <p>
          Travelers are responsible for ensuring they are medically and physically fit for their selected itinerary (for example, high-altitude destinations such as Ladakh or Nepal).
        </p>

        <p>
          We strongly recommend comprehensive travel insurance for all domestic and international travel.
        </p>

        <hr />

        <h3>5. Itinerary Changes</h3>

        <p>
          While we strive to adhere strictly to confirmed itineraries, adjustments may become necessary due to operational, safety, regulatory, or weather-related reasons.
        </p>

        <p>
          Any such modifications will be communicated promptly, and alternatives will be arranged wherever possible.
        </p>

        <hr />

        <h3>6. MICE & Corporate Programs</h3>

        <p>
          For Meetings, Incentives, Conferences, Exhibitions, and corporate group travel programs, additional contractual terms apply as outlined in the formal proposal or signed agreement.
        </p>

        <p>Event execution remains subject to:</p>

        <ul>
          <li>Venue contracts</li>
          <li>Airline agreements</li>
          <li>Delegate numbers and attrition clauses</li>
          <li>Production and branding approvals</li>
          <li>Payment milestone compliance</li>
        </ul>

        <p>
          All corporate engagements are governed by mutually agreed written documentation.
        </p>

        <hr />

        <h3>7. External Links Disclaimer</h3>

        <p>
          This website may contain links to third-party websites such as tourism boards, airline portals, or partner platforms.
        </p>

        <p>
          We have no control over the nature, content, or availability of these external sites. The inclusion of such links does not imply endorsement of their views or policies.
        </p>

        <hr />

        <h3>8. Governing Law & Jurisdiction</h3>

        <p>
          All bookings and transactions with Plenary Holidays shall be governed by the laws of India.
        </p>

        <p>
          Any disputes arising shall be subject to the exclusive jurisdiction of the courts in New Delhi, India.
        </p>

        <hr />

        <h3>Contact Information</h3>

        <p>
          For clarification regarding this Disclaimer or other legal policies, please contact us
        </p>

      </Container>
    </section>
  );
};

export default Disclaimer;